import React from "react";
import { requireAuth } from "utilities/auth";
import RegistryEditor from "components/Settings/RegistryEditor";
import { useAgents } from "hooks/useRegistries";
import { apiRoutes } from "constants/apiRoutes";
import { Handshake } from "lucide-react";

/**
 * AgentsRegistry (SOUND-672) — /settings/agents. Internal-only.
 *
 * The first link in the AGENT -> PROCESSOR -> SPONSOR BANK chain: who a deal
 * came through. Today that is recorded nowhere; the Notion export buried it in
 * one free-text column ("Maverick (through Goat)", "MAVERICK (MPP)").
 *
 * The label is "Agents", NEVER "ISOs". An agent is an ISO for a processor and a
 * processor is itself an ISO for its banks — Kurv is an ISO of BMO, Esquire,
 * Merrick and Central Bank of St. Louis — so the term points both directions
 * and names neither role.
 *
 * All behaviour lives in the shared RegistryEditor; agents and banks carry the
 * same four fields, so this file is configuration, not logic.
 */
function AgentsRegistry() {
  return (
    <RegistryEditor
      title="Agents"
      subtitle="Who a deal came through — the referring agent or office that sits in front of a processor. Not the same thing as a Sound partner, and deliberately not called an ISO: a processor is itself an ISO for its banks."
      icon={Handshake}
      noun="agent"
      idKey="agentId"
      useList={useAgents}
      routes={{
        create: apiRoutes.createAgent,
        update: apiRoutes.updateAgent,
        remove: apiRoutes.deleteAgent,
      }}
      createHint="Add an agent the seed did not cover."
      emptyDescription="Add the agents deals come through so MID applications have something to point at."
      tagsHint="Free-form labels for grouping and search — e.g. a processor an agent usually writes to."
    />
  );
}

export default requireAuth(AgentsRegistry);
